export default {
  install(Vue) {
    Vue.mixin({
      beforeCreate() {
        const vm = this;

        this.$rtdb = {
          _listeners: [],

          on(ref, event, cb) {
            ref.on(event, cb, (error) => {
              console.error("Firebase", error.code, error.message);
            });

            vm.$rtdb._listeners.push({ ref, event, cb });
          },

          off() {
            vm.$rtdb._listeners.forEach(({ ref, event, cb }) => {
              ref.off(event, cb);
            });

            vm.$rtdb._listeners = [];
          },

          getListeners() {
            return vm.$rtdb._listeners;
          },
        };
      },

      beforeDestroy() {
        if (this.$rtdb) {
          this.$rtdb.off();
        }
      },
    });
  },
};
